import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Tag from '../../../Tags/Tag';
import direction from '../../../../assets/recommended/direction.png';
import { setCurrentCourse } from '../../../../store/actions/appActions';
import { COURSES } from '../../../../constants/courses';
import { CoursesModifications } from '../../../../types/courses/courses';

import { RestoreWrapper, TagsWrapper, RestoreImage, RestoreContent, RestoreBottom } from './styled';
import useMediaQuery from '../../../../utils/breakpoints/useMediaQuery';

const DirectionProgressio = () => {
   const { t } = useTranslation();
   const dispatch = useDispatch();
   const { isMobile } = useMediaQuery();

   const handleSelectCourse = () => {
      dispatch(setCurrentCourse({ courseModification: COURSES.chooseDirectionProposal as CoursesModifications }));
   }

   return (
      <Link to={`/cabinet/${COURSES.chooseDirectionProposal}`} >
         <RestoreWrapper onClick={handleSelectCourse} isMobile={isMobile}>
            <RestoreImage isMobile={isMobile} src={direction} />
            <RestoreContent isMobile={isMobile} >
               <TagsWrapper>
                  <Tag name="Teens" />
               </TagsWrapper>
               <RestoreBottom isMobile={isMobile}> 
                  <h1>{t('course.chooseDirectionProposal.title')}</h1>
                  <p>{t('course.chooseDirectionProposal.description')}</p>
            </RestoreBottom>  
            </RestoreContent>
         </RestoreWrapper>
      </Link>
   );
};

export default DirectionProgressio;